import gql from 'graphql-tag';

export const UPDATE_ACADEMIC_REFEREE = gql`
  mutation (
    $id: ID!
    $title: String!
    $surname: String!
    $givenName: String!
    $institution: String!
    $position: String!
    $relationship: String!
    $email: String!
    $phoneNumber: String!
    $faxNumber: String!
  ) {
    updateAcademicReferee(
      id: $id
      input: {
        title: $title
        name: { surname: $surname, givenName: $givenName }
        institution: $institution
        position: $position
        relationship: $relationship
        email: $email
        phoneNumber: $phoneNumber
        faxNumber: $faxNumber
      }
    ) {
      _id
    }
  }
`;
